module.exports = __webpack_public_path__ + "static/media/img-card-man.19a01e04.png";